(() => {
  const initializeProductHub = (hub) => {
    if (!hub || hub.dataset.productHubReady === 'true') return;

    hub.dataset.productHubReady = 'true';

    const tabs = Array.from(hub.querySelectorAll('[data-hub-tab]'));
    const panels = Array.from(hub.querySelectorAll('[data-hub-panel]'));

    if (!tabs.length || !panels.length) return;

    const activateTab = (nextTab, moveFocus = false) => {
      const target = nextTab.dataset.hubTab;
      const nextPanel = panels.find((panel) => panel.dataset.hubPanel === target);

      if (!nextPanel) return;

      tabs.forEach((tab) => {
        const isActive = tab === nextTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const isActive = panel === nextPanel;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        panel.classList.remove('is-entering');
      });

      requestAnimationFrame(() => {
        nextPanel.classList.add('is-entering');
      });

      if (moveFocus) nextTab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));

      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex === null) return;

        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });
  };

  const initializeAllProductHubs = (scope = document) => {
    scope.querySelectorAll('[data-product-hub]').forEach(initializeProductHub);
  };

  document.addEventListener('DOMContentLoaded', () => initializeAllProductHubs());

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllProductHubs(event.target);
  });
})();
